import React, { FC } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { ISSUE_STATUS_LABEL, TIssueState } from 'constants/issueStatus'
import { TIssueStateOnClick, TStatus } from './types'

interface IIsueStateButtonProps {
  selected: boolean
  onClick: TIssueStateOnClick
  count: number
  status: TStatus
  issueState: TIssueState
}

const useIssueStateButtonStyles = makeStyles({
  btnNoOverflow: {
    textAlign: 'start',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
})

const IssueStateButton: FC<IIsueStateButtonProps> = ({
  count = 0,
  issueState,
  onClick,
  selected,
  status,
}) => {
  const styles = useIssueStateButtonStyles()
  const clickHandler = () => onClick(issueState, status, selected)

  const className = classNames('btn-text-link', styles.btnNoOverflow, {
    b: selected,
    i: selected,
  })

  return (
    <button className={className} onClick={clickHandler} data-test='issue-state-button'>
      <span>{count}</span> {ISSUE_STATUS_LABEL[issueState]}
    </button>
  )
}

export default IssueStateButton
